import Toggle from "immigram-ui-cmon/src/components/Toggle/Toggle";
import React from "react";
import { Control, Controller } from "react-hook-form";

import { ValidationError } from "@/lib/hook/useValidation";

import {
  ImmigramFormElementConfigBase,
  ImmigramFormElementOnChange,
  ImmigramFormElementType,
  useModifiedConfigParamValue,
} from "./common";

export interface ImmigramFormElementConfigToggle
  extends ImmigramFormElementConfigBase {
  type: ImmigramFormElementType.Toggle;
  title: string;
  name: string;
}

interface ImmigramFormToggleProps {
  elementConfig: ImmigramFormElementConfigToggle;
  control: Control;
  onChange: ImmigramFormElementOnChange;
  disabled: boolean;
  validationErrors?: ValidationError | null;
}

function ImmigramFormToggle(props: ImmigramFormToggleProps) {
  const { elementConfig, control, disabled } = props;
  const title = useModifiedConfigParamValue(elementConfig.title);

  return (
    <Controller
      control={control}
      name={elementConfig.name}
      render={({ field: { onChange, value } }) => (
        <Toggle
          label={title}
          isEnabled={value === "true"}
          disabled={disabled}
          onChange={() => {
            const nextValue = value === "true" ? "false" : "true";

            onChange(nextValue);
            if (props.onChange && typeof value === "string") {
              props.onChange(elementConfig.name, nextValue);
            }
          }}
        />
      )}
    />
  );
}

export { ImmigramFormToggle };
